import { TLabel } from './locales'

export enum EVariableType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DATETIME = 'DATETIME',
  FLOAT = 'FLOAT',
  OPTIONS = 'OPTIONS',
  INTEGER_VALUE_RANGE = 'INTEGER_VALUE_RANGE',
  AMSLER_GRID = 'AMSLER_GRID',
  TIME = 'TIME',
  MEDIA = 'MEDIA',
}

export type TVariable = {
  id: number
  name?: string
  intlLabel: TLabel
  group?: string
  type: EVariableType
  minValue?: number
  maxValue?: number
  settings?: VariableSettingInterface
  VariableOptions?: TVariableOptions[]
}

export type TVariableOptions = {
  id: number
  answerOptions: string[]
  target: string
  value: string
  position: number
  UISize?: number
  VariableId: number
  Variable?: TVariable
}

export type TVariableConnectionInterface = {
  questionAnswer: string
  nextVariableName: string
}

export type TVariableUiInterface = {
  title: string
  text: string
}

export type TDocumentDefinition = {
  maxSizeMb?: number
  allowedMimeTypes?: string[]
}

export type VariableSettingInterface = {
  connections: TVariableConnectionInterface[]
  scoringRules: string[]
  isScoringVariable: boolean
  ui: TVariableUiInterface[]
  documentDefinition?: TDocumentDefinition
}

export type TDeprecatedPatientVariable = {
  id: number
  PatientId: number
  variableName: string
  label: TLabel
  tooltipText?: TLabel
  value?: boolean
}

export type TPatientVariable = {
  id: number
  patientAnswer: string // should never be used in frontend app, use value instead
  label?: string
  name?: string
  value?: boolean | number | string | Date
  gridCenterIsHit?: boolean
  Variable: {
    intlLabel?: TLabel
    label: string
    name?: string
    type?: EVariableType
    maxValue?: any
    settings?: { isScoringVariable?: boolean } | null
    group?: string
  }
  VariableId: number
}
